import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Alert,
  Chip,
  IconButton,
  TextField,
  InputAdornment,
  Grid,
  Avatar,
  Tooltip,
  Button,
  Pagination,
  Stack,
  CardActions,
  Divider,
} from "@mui/material";
import { CardActionArea } from "@mui/material";
// import { useNavigate } from "react-router-dom";
import {
  Search as SearchIcon,
  DirectionsBus as BusIcon,
  DirectionsCarFilled as CarIcon,
  LocalShipping as VanIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
  Refresh as RefreshIcon,
  People as PeopleIcon,
  CalendarToday as CalendarIcon,
  CheckCircle as ApprovedIcon,
  Pending as PendingIcon,
} from "@mui/icons-material";
import VehicleServices from "../../services/externalServices/trackingservices/vehicleServices";
import UserApprovalServices from "../../services/externalServices/trackingservices/userApprovalServices";
import { getOwnerIdFromLocalStorage } from "../../utils/auth"; // Import the utility function
import { useNavigate } from "react-router-dom";
import VehicleLocationMap from "./VehicleLocationMap";
import TrackingServices from "../../services/externalServices/trackingservices/trackingServices";
const VehicleManagement = () => {
  const [vehicles, setVehicles] = useState([]);
  const [filteredVehicles, setFilteredVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [itemsPerPage] = useState(12);
  const [vehicleLocations, setVehicleLocations] = useState();
  const [tripCounts, setTripCounts] = useState({
    total: 0,
    started: 0,
    notStarted: 0,
  });

  // NEW: Get owner ID from localStorage
  const [ownerId, setOwnerId] = useState(null);
  const [userDetails, setUserDetails] = useState([]);
  const [activeTripType, setActiveTripType] = useState(getTripTypeByTime());

  // User counts state
  const [userCounts, setUserCounts] = useState({
    APPROVED: 0,
    PENDING: 0,
    REJECTED: 0,
  });
  const navigate = useNavigate();

  // Initialize owner ID from localStorage on component mount
  useEffect(() => {
    const ownerIdFromStorage = getOwnerIdFromLocalStorage();
    console.log("Owner ID from localStorage:", ownerIdFromStorage);

    if (ownerIdFromStorage) {
      setOwnerId(ownerIdFromStorage);
    } else {
      setError("No owner access found. Please login again.");
      setLoading(false);
    }
  }, []);

  // Fetch data when owner ID is available
  useEffect(() => {
    if (ownerId) {
      fetchData();
    }
  }, [ownerId]);

 function getTripTypeByTime() {
  const now = new Date();
  const hour = now.getHours();
  if (hour >= 8 && hour < 16) return "pickup";
  return "drop";
}

  const fetchTripCounts = async () => {
    try {
      const tripType = getTripTypeByTime();
      setActiveTripType(tripType);

      const res = await TrackingServices.getTripSummary({
        ownerId,
        tripType, // pickup or drop
      });

      setTripCounts({
        total: res?.counts?.total ?? 0,
        started: res?.counts?.started ?? 0,
        notStarted: res?.counts?.notStarted ?? 0,
      });
    } catch (err) {
      console.error("Failed to fetch trip counts", err);
    }
  };

  useEffect(() => {
     if (!ownerId) {
      console.warn("No owner ID available for fetching data");
      return;
    }
    fetchTripCounts();

    const interval = setInterval(() => {
      const newType = getTripTypeByTime();
      if (newType !== activeTripType) {
        fetchTripCounts();
      }
    }, 60 * 1000); // check every 1 minute

    return () => clearInterval(interval);
  }, [ownerId, activeTripType]);

  // Filter vehicles based on search term
  useEffect(() => {
    if (searchTerm) {
      const filtered = vehicles.filter(
        (vehicle) =>
          vehicle.vehicle_number
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          vehicle.alias_number
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          vehicle.vehicle_type
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          vehicle.approval_status
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase())
      );
      setFilteredVehicles(filtered);
    } else {
      setFilteredVehicles(vehicles);
    }
    setPage(1);
  }, [searchTerm, vehicles]);

  const fetchVehicleLocations = async () => {
    try {
      if (!ownerId) {
        console.warn("No owner ID available for fetching data");
        return;
      }
      const response = await VehicleServices.getALLVehicleLocation(ownerId);
      console.log("Vehicle locations response:", response);
      setVehicleLocations(response);
    } catch (err) {
      console.error("Failed to fetch vehicle locations:", err);
    }
  };

  useEffect(() => {
    fetchVehicleLocations();
  }, [ownerId]);

  // Combined data fetching function
  const fetchData = async () => {
    if (!ownerId) {
      console.warn("No owner ID available for fetching data");
      return;
    }

    await Promise.all([fetchVehicles(), fetchUserCounts()]);
  };
  const openVehicleDetails = (vehicle) => {
    navigate(`/vehicles/${vehicle._id}`, { state: { vehicleId: vehicle._id } }); // optional state pass
  };

  const openVehicleLocation = (vehicle) => {
    navigate(`/busLocation/${vehicle._id}`, {
      state: { vehicleId: vehicle._id },
    }); // optional state pass
  };

  const fetchVehicles = async () => {
    try {
      setLoading(true);
      setError(null);
      console.log("Fetching vehicles for owner:", ownerId);

      const response = await VehicleServices.getVehiclesByOwnerId(ownerId);
      console.log("Vehicles response:", response);

      const vehicleData =
        response?.data?.vehicles || response?.data || response || [];
      setVehicles(vehicleData);
      setFilteredVehicles(vehicleData);
    } catch (err) {
      console.error("Failed to fetch vehicles:", err);
      setError(err.message || "Failed to fetch vehicles");
    } finally {
      setLoading(false);
    }
  };

  const fetchUserCounts = async () => {
    try {
      console.log("Fetching user counts for owner:", ownerId);

      /* axios response looks like:
       { data: { success:true, summary:{APPROVED:2,PENDING:0}, data:[…] } }
    */
      const res = await UserApprovalServices.getUserApprovalCountByOwnerId(
        ownerId
      ); // ← your new route

      const { success, summary, data } = res || {};
      console.log("success, summary, data", success, summary, data);
      if (success) {
        // make sure we always keep ALL 3 keys
        setUserCounts({
          APPROVED: summary?.APPROVED ?? 0,
          PENDING: summary?.PENDING ?? 0,
          REJECTED: summary?.REJECTED ?? 0,
        });

        setUserDetails(data || []); // keep breakdown if you want to display later
      }
    } catch (err) {
      console.error("Failed to fetch user counts:", err);
    }
  };

  // Rest of your existing functions remain the same...
  const getVehicleIcon = (type) => {
    switch (type?.toLowerCase()) {
      case "bus":
        return <BusIcon sx={{ fontSize: 40, color: "primary.main" }} />;
      case "van":
        return <VanIcon sx={{ fontSize: 40, color: "secondary.main" }} />;
      case "car":
        return <CarIcon sx={{ fontSize: 40, color: "success.main" }} />;
      default:
        return <BusIcon sx={{ fontSize: 40, color: "primary.main" }} />;
    }
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
        return "success";
      case "pending":
        return "warning";
      case "rejected":
        return "error";
      default:
        return "default";
    }
  };

  const handleEdit = (vehicleId) => {
    console.log("Edit vehicle:", vehicleId);
  };

  const handleDelete = async (vehicleId) => {
    if (window.confirm("Are you sure you want to delete this vehicle?")) {
      try {
        await VehicleServices.deleteVehicleById(vehicleId);
        fetchVehicles();
      } catch (err) {
        console.error("Failed to delete vehicle:", err);
      }
    }
  };

  const handleAddVehicle = () => {
    console.log("Add new vehicle");
  };

  // Calculate pagination
  const totalPages = Math.ceil(filteredVehicles.length / itemsPerPage);
  const startIndex = (page - 1) * itemsPerPage;
  const paginatedVehicles = filteredVehicles.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const openApproved = () =>
    navigate("/user-approvals", { state: { users: userDetails } });

  /* ─────────────────── render ─────────────────── */
  if (!ownerId || loading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <CircularProgress />
      </Box>
    );

  // Show loading while getting owner ID or fetching data
  if (!ownerId || loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <CircularProgress size={60} />
        <Typography variant="h6" sx={{ ml: 2 }}>
          {!ownerId ? "Initializing..." : "Loading dashboard..."}
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
        <Button
          variant="contained"
          onClick={fetchData}
          startIcon={<RefreshIcon />}
        >
          Retry
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      {/* Header */}
      <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
        <Grid item xs={12} md={6}>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
            Dashboard Overview
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Owner ID: {ownerId} • {filteredVehicles.length} vehicles •{" "}
            {userCounts.APPROVED + userCounts.PENDING + userCounts.REJECTED}{" "}
            users
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{ textAlign: { xs: "left", md: "right" } }}
        >
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleAddVehicle}
            sx={{ mr: 1 }}
          >
            Add Vehicle
          </Button>
          <Button
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={fetchData}
          >
            Refresh
          </Button>
        </Grid>
      </Grid>

      {/* Summary Cards */}
      {/* ───────── Summary (full-width, compact) ───────────────── */}
      <Grid container spacing={1} sx={{ mb: 2 }}>
        {" "}
        {/* spacing 3 ➞ 1 */}
        {/* Buses */}
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ bgcolor: "primary.light", color: "white" }}>
            <CardContent sx={{ p: 1.5 }}>
              {" "}
              {/* tighter padding */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Avatar sx={{ bgcolor: "primary.main", width: 32, height: 32 }}>
                  <BusIcon fontSize="small" />
                </Avatar>
                <Box>
                  <Typography variant="h6">
                    {" "}
                    {/* h5 ➞ h6 */}
                    {vehicles.filter((v) => v.vehicle_type === "Bus").length}
                  </Typography>
                  <Typography variant="caption">Buses</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        {/* Approved users */}
        <Grid item xs={12} sm={6} md={3}>
          <Card
            onClick={openApproved}
            sx={{
              bgcolor: "success.light",
              color: "white",
              cursor: "pointer",
              "&:hover": { boxShadow: 4 },
            }}
          >
            <CardContent sx={{ p: 1.5 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Avatar sx={{ bgcolor: "success.main", width: 32, height: 32 }}>
                  <ApprovedIcon fontSize="small" />
                </Avatar>
                <Box>
                  <Typography variant="h6">{userCounts.APPROVED}</Typography>
                  <Typography variant="caption">Approved Users</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        {/* Pending users */}
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ bgcolor: "warning.light", color: "white" }}>
            <CardContent sx={{ p: 1.5 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Avatar sx={{ bgcolor: "warning.main", width: 32, height: 32 }}>
                  <PendingIcon fontSize="small" />
                </Avatar>
                <Box>
                  <Typography variant="h6">{userCounts.PENDING}</Typography>
                  <Typography variant="caption">Pending Users</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        {/* Total capacity */}
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ bgcolor: "info.light", color: "white" }}>
            <CardContent sx={{ p: 1.5 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Avatar sx={{ bgcolor: "info.main", width: 32, height: 32 }}>
                  <PeopleIcon fontSize="small" />
                </Avatar>
                <Box>
                  <Typography variant="h6">
                    {vehicles.reduce((sum, v) => sum + (v.capacity || 0), 0)}
                  </Typography>
                  <Typography variant="caption">Total Capacity</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
   {/* Trip Summary Section */}
<Box sx={{ mb: 3 }}>
  {/* Header / Label */}
  <Typography
    variant="subtitle1"
    fontWeight={600}
    sx={{ mb: 2 }}
    color={activeTripType === "pickup" ? "success.main" : "warning.main"}
  >
    Showing {activeTripType.toUpperCase()} Trips (
    {activeTripType === "pickup" ? "08:00 AM – 04:00 PM" : "After 04:00 PM"})
  </Typography>

  {/* Cards */}
  <Grid container spacing={2}>
    {/* Total Trips */}
    {/* <Grid item xs={12} sm={4}>
      <Card sx={{ bgcolor: "info.light", color: "white" }}>
        <CardContent sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
          <Avatar sx={{ bgcolor: "info.main", width: 40, height: 40 }}>
            <BusIcon fontSize="medium" />
          </Avatar>
          <Box>
            <Typography variant="h5" fontWeight={600}>
              {tripCounts.total}
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.85 }}>
              Total Trips
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Grid> */}

    {/* Started Trips */}
    <Grid item xs={12} sm={4}>
      <Card sx={{ bgcolor: "success.light", color: "white" }}>
        <CardContent sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
          <Avatar sx={{ bgcolor: "success.main", width: 40, height: 40 }}>
            <ApprovedIcon fontSize="medium" />
          </Avatar>
          <Box>
            <Typography variant="h5" fontWeight={600}>
              {tripCounts.started}
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.85 }}>
              Started Trips
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Grid>

    {/* Not Started Trips */}
    <Grid item xs={12} sm={4}>
      <Card sx={{ bgcolor: "warning.light", color: "white" }}>
        <CardContent sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
          <Avatar sx={{ bgcolor: "warning.main", width: 40, height: 40 }}>
            <PendingIcon fontSize="medium" />
          </Avatar>
          <Box>
            <Typography variant="h5" fontWeight={600}>
              {tripCounts.notStarted}
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.85 }}>
              Not Started Trips
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Grid>
  </Grid>
</Box>


      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <VehicleLocationMap
                vehicles={vehicleLocations}
                onRefresh={fetchVehicleLocations}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Search */}
      {/* <Card sx={{ mb: 3 }}>
        <CardContent>
          <TextField
            fullWidth
            placeholder="Search vehicles by number, type, or status..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </CardContent>
      </Card> */}

      {/* Vehicle Tiles */}
      {paginatedVehicles.length === 0 ? (
        <Card sx={{ p: 4, textAlign: "center", borderRadius: 3 }}>
          <Typography variant="h6" color="text.secondary">
            {searchTerm
              ? "No vehicles found matching your search."
              : "No vehicles found."}
          </Typography>
        </Card>
      ) : (
        <Grid container spacing={3}>
          {paginatedVehicles.map((vehicle) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={vehicle._id}>
              <Card
                sx={{
                  height: "100%",
                  borderRadius: 3,
                  display: "flex",
                  flexDirection: "column",
                  transition: "all 0.25s ease",
                  boxShadow: "0 6px 20px rgba(0,0,0,0.06)",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: "0 12px 30px rgba(0,0,0,0.12)",
                  },
                }}
              >
                {/* Header */}
                <Box
                  sx={{
                    background:
                      "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                    color: "#fff",
                    p: 2,
                    borderTopLeftRadius: 12,
                    borderTopRightRadius: 12,
                    textAlign: "center",
                  }}
                >
                  {getVehicleIcon(vehicle.vehicle_type)}
                  <Typography fontWeight={600} mt={1}>
                    {vehicle.vehicle_number}
                  </Typography>
                  {vehicle.alias_number && (
                    <Typography variant="caption" sx={{ opacity: 0.9 }}>
                      Alias: {vehicle.alias_number}
                    </Typography>
                  )}
                </Box>

                {/* Body */}
                <CardActionArea
                  onClick={() => openVehicleLocation(vehicle)}
                  sx={{ flexGrow: 1 }}
                >
                  <CardContent sx={{ p: 2 }}>
                    {/* Chips */}
                    <Stack
                      direction="row"
                      spacing={1}
                      justifyContent="center"
                      mb={2}
                    >
                      <Chip
                        label={vehicle.vehicle_type}
                        size="small"
                        color="primary"
                      />
                      <Chip
                        label={vehicle.trackingMethod}
                        size="small"
                        variant="outlined"
                      />
                    </Stack>

                    {/* Details */}
                    <Stack spacing={1}>
                      <Box display="flex" alignItems="center" gap={1}>
                        <PeopleIcon fontSize="small" color="action" />
                        <Typography variant="body2">
                          Capacity: {vehicle.capacity || "N/A"}
                        </Typography>
                      </Box>

                      <Box display="flex" alignItems="center" gap={1}>
                        <CalendarIcon fontSize="small" color="action" />
                        <Typography variant="body2">
                          {vehicle.created_at
                            ? new Date(vehicle.created_at).toLocaleDateString()
                            : "N/A"}
                        </Typography>
                      </Box>
                    </Stack>
                  </CardContent>
                </CardActionArea>

                {/* Footer Actions */}
                <Divider />
                {/* <CardActions sx={{ justifyContent: "space-between", px: 2 }}>
                  <Tooltip title="Edit Vehicle">
                    <IconButton
                      size="small"
                      color="primary"
                      onClick={() => handleEdit(vehicle._id)}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Tooltip> */}

                  {/* <Tooltip title="Delete Vehicle">
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => handleDelete(vehicle._id)}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip> */}
                {/* </CardActions> */}
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Pagination */}
      {totalPages > 1 && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={handlePageChange}
            color="primary"
            size="large"
            showFirstButton
            showLastButton
          />
        </Box>
      )}

      {/* Results Info */}
      <Box sx={{ textAlign: "center", mt: 2 }}>
        <Typography variant="body2" color="textSecondary">
          Showing {startIndex + 1}-
          {Math.min(startIndex + itemsPerPage, filteredVehicles.length)} of{" "}
          {filteredVehicles.length} vehicles
        </Typography>
      </Box>
    </Box>
  );
};

export default VehicleManagement;
